import type { Dispatch, SetStateAction } from 'react';
import { DrpxLogoIcon } from '../logo/DrpxLogo';
import type { TranslateFn } from '../../types';

interface WartungsScreenProps {
  wartungInput: string;
  setWartungInput: Dispatch<SetStateAction<string>>;
  wartungPruefen: () => void;
  t: TranslateFn;
}

/** WartungsScreen — Zugangscode-Eingabe bei aktivem Wartungsmodus. */
export function WartungsScreen({
  wartungInput,
  setWartungInput,
  wartungPruefen,
  t,
}: WartungsScreenProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000000',
        fontFamily: "'DM Sans',sans-serif",
      }}>
      <div className="grain-overlay" />
      <div
        style={{ textAlign: 'center' as const, maxWidth: 380, padding: '0 20px', animation: 'fadeInScale .5s ease' }}>
        <div style={{ marginBottom: 24 }}>
          <DrpxLogoIcon size={1.0} />
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 6 }}>
          {t('hcWartungsmodus')}
        </div>
        <div
          style={{ fontSize: 13, color: 'rgba(255,255,255,.45)', marginBottom: 28, lineHeight: 1.6 }}>
          {t('hcTestbetrieb')}
          <br />
          {t('hcZugangscode')}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            value={wartungInput}
            onChange={function (e) {
              setWartungInput(e.target.value);
            }}
            onKeyDown={function (e) {
              if (e.key === 'Enter') wartungPruefen();
            }}
            placeholder={t('hcZugangscodePh')}
            type="password"
            autoFocus={true}
            style={{
              flex: 1,
              background: 'rgba(255,255,255,.08)',
              border: '1px solid rgba(255,255,255,.15)',
              borderRadius: 10,
              padding: '12px 16px',
              color: '#fff',
              fontSize: 14,
              fontFamily: "'DM Sans',sans-serif",
              outline: 'none',
            }} />
          <button
            onClick={wartungPruefen}
            style={{
              background: 'linear-gradient(135deg,#d97706,#f59e0b)',
              border: 'none',
              color: '#fff',
              borderRadius: 10,
              padding: '12px 20px',
              fontSize: 13,
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(245,158,11,.25)',
            }}>
            →
          </button>
        </div>
      </div>
    </div>
  );
}
